<script>
  import { onMount, onDestroy } from "svelte";
  import { writable } from "svelte/store";

  import ChartPie from "./ChartPie.svelte";
  import SeatGhost from "./SeatGhost.svelte";
  import { resultData, fetchSeats, candidates, intervalDuration, newestSource } from "../store";

  let intervalId;
  export const currentSource = writable(null);

  const typeMapping = {
    exit_poll: "Prognose",
    projection: "Hochrechnung",
    preliminary: "Vorl. amtl. Endergebnis",
    official: "Amtl. Endergebnis",
  };

  function formatTime(isoString) {
    const date = new Date(isoString);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes} Uhr`;
  }

  $: if ($resultData.length > 0) {
    let thisSource = $newestSource;
    updateSeatData(thisSource);
  }

  onMount(() => {
    let unsubscribe = intervalDuration.subscribe((time) => {
      clearInterval(intervalId);
      intervalId = setInterval(fetchSeats, time);
    });
    fetchSeats();
    return () => {
      unsubscribe();
      clearInterval(intervalId);
    };
  });

  onDestroy(() => {
    clearInterval(intervalId);
  });
  let selectedIndex = $currentSource;
  const seatData = writable([]);

  function updateSeatData(index) {
    selectedIndex = index;
    currentSource.set(index);

    const processedSeats = $resultData[index].seats.map((party) => ({
      seats: party.seats,
      party_name: party.party_name,
      change: party.change,
      party: party.party,
      color: `var(--dv-${party.party})` || "var(--dv-grey700)",
    }));
    seatData.set(processedSeats);
  }

  console.log(seatData);
</script>

{#if $resultData.length}
  <!-- <div class="source">
    {#if $resultData.some((result) => result.result_type === "official" || result.result_type === "preliminary")}
      <div class="source-result">
        {typeMapping[$resultData[$currentSource].result_type]}
        {formatTime($resultData[$currentSource].status_date)}
      </div>
    {:else}
      <div class="button-group">
        {#each $resultData as result, index}
          <input
            bind:group={selectedIndex}
            on:click={() => updateSeatData(index)}
            type="radio"
            id="source{index}"
            name="sources"
            value={index}
          />
          <label
            for="source{index}"
            class="{index === 0 ? 'first' : ''} {index === $resultData.length - 1 ? 'last' : ''}">{result.source}</label
          >
        {/each}
      </div>
      <div class="source-status">
        {typeMapping[$resultData[$currentSource].result_type]}
        {formatTime($resultData[$currentSource].status_date)}
      </div>
    {/if}
  </div> -->
  <ChartPie {seatData} {candidates} />
{:else}
  <SeatGhost></SeatGhost>
{/if}
<div class="footnote">Grafik: kaho., rli., cbt., jpg. / Quellen: Bundeswahlleiterin, Deutscher Bundestag</div>
